import FigCaption from '@atoms/FigCaption/FigCaption';
import Image from '@atoms/Image/Image';
import Video from '@atoms/Video/Video';
import { IMediaWithCaption } from '@models/IMediaWithCaption';
import useMediaQuery from '@utility/hooks/useMediaQuery';
import classNames from 'classnames';

const MediaWithCaption = ({
  caption,
  image,
  mobileImage,
  mobileVideo,
  textAlignment,
  video,
  captionStyles,
  imageClasses,
}: IMediaWithCaption) => {
  const isMobile = useMediaQuery(752);

  const videoSource =
    isMobile && mobileVideo?.videoSource
      ? mobileVideo?.videoSource
      : video?.videoSource;

  const imageSource = isMobile && mobileImage ? mobileImage : image;
  return (
    <FigCaption
      caption={caption}
      textAlignment={textAlignment}
      captionStyles={captionStyles}
    >
      {videoSource ? (
        <Video
          classes={
            isMobile && mobileVideo?.videoSource ? 'tw-aspect-[9/16]' : ''
          }
          poster={imageSource}
          videoSource={videoSource}
        />
      ) : (
        <Image
          image={imageSource}
          imageClasses={classNames('tw-w-full', imageClasses)}
        />
      )}
    </FigCaption>
  );
};

export default MediaWithCaption;
